import React from "react";
import "./questionnaire.css";

export default function QuestionInput({ question, formik }) {
  const { values, setFieldValue } = formik;


  const isSelected = value => values.answer?.trim() === value?.trim();

  switch (question.type) {
    case "number":
      return (
        <input
          className="input"
          type="number"
          value={values.answer ?? ""}
          onChange={e =>
            setFieldValue("answer", Number(e.target.value))
          }
        />
      );

    case "text":
      return (
        <textarea
          className="input"
          rows={4}
          value={values.answer ?? ""}
          onChange={e =>
            setFieldValue("answer", e.target.value)
          }
        />
      );

    case "short":
      return (
        <input
          className="input"
          type="text"
          value={values.answer ?? ""}
          onChange={e =>
            setFieldValue("answer", e.target.value)
          }
        />
      );
    case "multiple": // ✅ BACKEND TYPE
      return (
        <div className="option-grid">
          {question.options?.map(opt => (
            <button
              key={opt.text}
              type="button"
              className={`option-btn ${isSelected(opt.text) ? "active" : ""
                }`}
              onClick={() =>
                setFieldValue("answer", opt.text)
              }
            >
              {opt.text}
            </button>
          ))}
        </div>
      );

    default:
      return null;
  }
}
